import {HttpClient} from '../core/request'
import createStore from './createStore'
import { loadCategories } from './category'

// ------------------------------------
// Constants
// ------------------------------------
export const SET_FILTER_REGIONS = 'SET_FILTER_REGIONS';
export const SET_FILTER_CITIES = 'SET_FILTER_CITIES';

export const SET_FLAGS_CITY = 'SET_FLAGS_CITY';
export const SET_FLAGS_REGION = 'SET_FLAGS_REGION';
// ------------------------------------
// Actions
// ------------------------------------
export function setFilterRegions(regions) {
    return {
        type: SET_FILTER_REGIONS,
        payload: regions
    }
}

export function setFilterCities(cities) {
    return {
        type: SET_FILTER_CITIES,
        payload: cities
    }
}

export function setFlagsCity(cities) {
    createStore.dispatch(loadCategories(cities));
    return {
        type: SET_FLAGS_CITY,
        payload: cities
    }
}

export function setFlagsRegion(regions) {
    createStore.dispatch(loadCategories([], regions));
    return {
        type: SET_FLAGS_REGION,
        payload: regions
    }
}

export const loadRegions = (callback) => {
    return (dispatch, getState) => {
        return HttpClient().get('region/top').then(resp => {
            dispatch(setFilterRegions(resp.data));
            if (callback != null) {
                callback(resp.data);
            }
        }).catch(error => {
            console.log('Error', error)
        })
    }
};

export const loadCities = (zip) => {
    return (dispatch, getState) => {
        return HttpClient(true).get('region/find-cities/' + zip).then(resp => {
            dispatch(setFilterCities(resp.data));
        }).catch(error => {
            console.log('Error', error)
        })
    }
};

// ------------------------------------
// Reducer
// ------------------------------------
export function filterRegionsReducer(state = [], action) {
    return action.type === SET_FILTER_REGIONS
        ? action.payload
        : state
}

export function filterCitiesReducer(state = [], action) {
    return action.type === SET_FILTER_CITIES
        ? action.payload
        : state
}

export function searchFilterCityReducer(state = [], action) {
    return action.type === SET_FLAGS_CITY
        ? action.payload
        : state
}

export function searchFilterRegionReducer(state = [], action) {
    return action.type === SET_FLAGS_REGION
        ? action.payload
        : state
}


// WEBPACK FOOTER //
// ./src/store/filters.js